module.exports = __webpack_public_path__ + "static/img/version5.68629c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version5.png
// module id = FW55
// module chunks = 1